<template>
  <div>
    <b-form-group
      class="input-group-var-regio"
      label="Regió:"
      label-size="sm"
      label-for="input-var-regio"
      label-cols="4"
    >
      <b-form-select
        required
        size="sm"
        id="input-var-regio"
        class="var-regio"
        v-model="regioSanitaria"
        :options="opcionsRegioSanitaria"
        @input="onUpdateRegioSanitaria"
      >
        <template v-slot:first>
          <b-form-select-option :value="null">Totes</b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "VariableRegioSanitaria",
  props: {
    initialValue: {
      required: true,
    },
  },
  data() {
    return {
      codiVariable: "regio-sanitaria",
      regioSanitaria: null,
      opcionsRegioSanitaria: [
        {
          value: "alt-pirineu-aran",
          text: this.$t("variables.regio.alt-pirineu-aran"),
        },
        { value: "lleida", text: this.$t("variables.regio.lleida") },
        {
          value: "camp-tarragona",
          text: this.$t("variables.regio.camp-tarragona"),
        },
        { value: "terres-ebre", text: this.$t("variables.regio.terres-ebre") },
        {
          value: "catalunya-central",
          text: this.$t("variables.regio.catalunya-central"),
        },
        { value: "girona", text: this.$t("variables.regio.girona") },
        {
          value: "barcelona-ciutat",
          text: this.$t("variables.regio.barcelona-ciutat"),
        },
        {
          value: "metropolita-nord",
          text: this.$t("variables.regio.metropolita-nord"),
        },
        {
          value: "metropolita-sud",
          text: this.$t("variables.regio.metropolita-sud"),
        },
      ],
    };
  },
  computed: {
    returnValue() {
      let r = { codi: this.codiVariable };
      if (this.regioSanitaria != null) {
        r.valor = this.regioSanitaria;
      }

      return r;
    },
  },
  methods: {
    onUpdateRegioSanitaria(newValue) {
      console.log(newValue);
      if (this.returnValue.valor) {
        this.$emit("variable-editada", this.returnValue);
      } else {
        this.$emit("variable-eliminada", this.codiVariable);
      }
    },
  },
  mounted() {
    if (this.initialValue != null) {
      this.regioSanitaria = this.initialValue.valor;
    }
  },
};
</script>

<style>
.var-regio {
  width: 180px;
}
.input-group-var-regio .col {
  text-align: left;
}
</style>
